export default function tagRemove(data = '') {
    if (data === null) {
        return '';
    }
    return data.replace(/(<([^>]+)>)/gi, '');
}
